import authInstance from 'config/axios.config';

export const roleServices = {
  getRoles: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== 'all' && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/admin/role?${params}`);
    return res.data;
  },

  addRole: async (payload) => {
    const res = await authInstance.post('/admin/role', payload);
    return res.data;
  },

  updateRole: async (payload) => {
    const { roleId, ...data } = payload;
    const res = await authInstance.patch(`/admin/role/${roleId}`, data);
    return res.data;
  },

  deleteRole: async (roleId) => {
    const res = await authInstance.delete(`/admin/role/${roleId}`);
    return res.data;
  },

  /*

  toggleActiveStatus: async (roleId) => {
    const res = await authInstance.patch(`/admin/role/${roleId}/toggle-active`);
    return res.data;
  },
  */
};
